/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_back4 = /** @type {(inputs: {}) => string} */ () => {
	return `Back`
};

const fr_back4 = /** @type {(inputs: {}) => string} */ () => {
	return `Retour`
};

const de_back4 = /** @type {(inputs: {}) => string} */ () => {
	return `Zurück`
};

const es_back4 = /** @type {(inputs: {}) => string} */ () => {
	return `Atrás`
};

const it_back4 = /** @type {(inputs: {}) => string} */ () => {
	return `Indietro`
};

const ar_back4 = /** @type {(inputs: {}) => string} */ () => {
	return `خلف`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const back4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.back4(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("back4", locale)
	if (locale === "en") return en_back4(inputs)
	if (locale === "fr") return fr_back4(inputs)
	if (locale === "de") return de_back4(inputs)
	if (locale === "es") return es_back4(inputs)
	if (locale === "it") return it_back4(inputs)
	return ar_back4(inputs)
};
export { back4 as "BACK" }